import { Arrows } from '@poseidon/components/StrokeIcons';
import { cn } from '@/clientOnlyUtils/cn';
import { type LinkProps } from 'next/link';
import type { ComponentProps } from 'react';
import React from 'react';

export type BreadcrumbsProps = ComponentProps<'div'> & {
  showStartingChevron?: boolean;
};
export type BreadcrumbProps = ComponentProps<'div'> & {
  backwards?: boolean;
};

export type BreadcrumbLinkProps = LinkProps & {
  children: ComponentProps<'a'>['children'];
  className?: ComponentProps<'a'>['className'];
  backwards?: boolean;
};

export default function Breadcrumbs({ children, showStartingChevron, className }: BreadcrumbsProps) {
  const filteredChildren = React.Children.map(children, (child, i) => {
    if (!React.isValidElement<BreadcrumbProps>(child)) return null;

    return (
      <>
        {(showStartingChevron || i > 0) && (
          <span className="size-4 text-[#d1d5de] *:h-full *:w-full">
            {child.props.backwards ? <Arrows.ChevronLeft /> : <Arrows.ChevronRight />}
          </span>
        )}
        {child}
      </>
    );
  })?.filter((a) => a);

  if (filteredChildren == null || filteredChildren.length <= 0) return null;
  return <div className={cn('flex items-center gap-2', className)}>{filteredChildren}</div>;
}
